// Reveal — IntersectionObserver fade-in (port of partials.js bindReveal 923-947).
function bindReveal() {
  document.documentElement.classList.add('js');
  const targets = new Set([
    ...document.querySelectorAll('main article.group, body > section article.group'),
    ...document.querySelectorAll('article.group'),
    ...document.querySelectorAll('body > section.relative h1, body > section.relative .text-white\\/70'),
    ...document.querySelectorAll('body > section a.group'),
    ...document.querySelectorAll('.h-section')
  ]);
  targets.forEach(el => el.classList.add('js-animation-fade-in'));
  if (!('IntersectionObserver' in window)) {
    targets.forEach(el => el.classList.add('animation-init'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (e.isIntersecting) {
        e.target.classList.add('animation-init');
        io.unobserve(e.target);
      }
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
  targets.forEach(el => io.observe(el));
}

if (document.readyState !== 'loading') bindReveal();
else document.addEventListener('DOMContentLoaded', bindReveal);
